import ReactMarkdown from "react-markdown";
import css from "./Markdown.module.css";

import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

// Custom link component to handle links within markdown
function MarkdownLinkElement({ href, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary hover:underline"
    >
      {children}
    </a>
  );
}

// Main component to render markdown content as a single paragraph
export function MarkdownLink({ content }) {
  // if there is ```, remove it
  if (content.includes("```")) {
    // remove it from content
    content = content.replace(/```/g, "");
  }
  return (
    <div className={`${css.markdownContainer}`}>
      <ReactMarkdown
        components={{ a: MarkdownLinkElement }}
        rehypePlugins={[rehypeRaw]}
        remarkPlugins={[remarkGfm]}
        remarkRehypeOptions={{ passThrough: ["link"] }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
